import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  index: null,
  maxStepReached: null
};

export default function flow (state = initialState, action) {
  const { type, step } = action;

  switch (type) {
  case types.FLOW_PROGRESS_UPDATE:
    return {
      ...state,
      step,
      maxStepReached: state.maxStepReached < step ? step : state.maxStepReached
    };

  case types.FLOW_PROGRESS_RESET:
    return {
      ...state,
      step: null
    };

  default:
    return state;
  }
}
